/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createAllotmentWithFareFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeAllotmentCreateRequest, serializeAllotmentUpdateRequest, serializeAllotmentWithFare, type AllotmentCreateRequest, type AllotmentUpdateRequest, type AllotmentWithFare, type ValidationProblemDetails } from '../models/index.js';
// @ts-ignore
import { ApproveRequestBuilderRequestsMetadata, type ApproveRequestBuilder } from './approve/index.js';
// @ts-ignore
import { ApproveBatchRequestBuilderRequestsMetadata, type ApproveBatchRequestBuilder } from './approveBatch/index.js';
// @ts-ignore
import { CancelUpdateAllotmentSizeRequestBuilderRequestsMetadata, type CancelUpdateAllotmentSizeRequestBuilder } from './cancelUpdateAllotmentSize/index.js';
// @ts-ignore
import { CreateCsvRequestBuilderRequestsMetadata, type CreateCsvRequestBuilder } from './createCsv/index.js';
// @ts-ignore
import { CreateCsvForHccRequestBuilderRequestsMetadata, type CreateCsvForHccRequestBuilder } from './createCsvForHcc/index.js';
// @ts-ignore
import { CreateCsvForTourOperatorRequestBuilderRequestsMetadata, type CreateCsvForTourOperatorRequestBuilder } from './createCsvForTourOperator/index.js';
// @ts-ignore
import { GetRequestBuilderRequestsMetadata, type GetRequestBuilder } from './get/index.js';
// @ts-ignore
import { GetFinalRequestBuilderRequestsMetadata, type GetFinalRequestBuilder } from './getFinal/index.js';
// @ts-ignore
import { GetForApprovalRequestBuilderRequestsMetadata, type GetForApprovalRequestBuilder } from './getForApproval/index.js';
// @ts-ignore
import { GetForHccRequestBuilderRequestsMetadata, type GetForHccRequestBuilder } from './getForHcc/index.js';
// @ts-ignore
import { GetForTourOperatorRequestBuilderNavigationMetadata, GetForTourOperatorRequestBuilderRequestsMetadata, type GetForTourOperatorRequestBuilder } from './getForTourOperator/index.js';
// @ts-ignore
import { AllotmentItemRequestBuilderNavigationMetadata, AllotmentItemRequestBuilderRequestsMetadata, type AllotmentItemRequestBuilder } from './item/index.js';
// @ts-ignore
import { RefreshRequestBuilderRequestsMetadata, type RefreshRequestBuilder } from './refresh/index.js';
// @ts-ignore
import { RejectRequestBuilderRequestsMetadata, type RejectRequestBuilder } from './reject/index.js';
// @ts-ignore
import { type UpdateAllotmentSizeRequestBuilder, UpdateAllotmentSizeRequestBuilderRequestsMetadata } from './updateAllotmentSize/index.js';
// @ts-ignore
import { type VerifyBusinessRuleRequestBuilder, VerifyBusinessRuleRequestBuilderNavigationMetadata, VerifyBusinessRuleRequestBuilderRequestsMetadata } from './verifyBusinessRule/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Allotment
 */
export interface AllotmentRequestBuilder extends BaseRequestBuilder<AllotmentRequestBuilder> {
    /**
     * The Approve property
     */
    get approve(): ApproveRequestBuilder;
    /**
     * The ApproveBatch property
     */
    get approveBatch(): ApproveBatchRequestBuilder;
    /**
     * The CancelUpdateAllotmentSize property
     */
    get cancelUpdateAllotmentSize(): CancelUpdateAllotmentSizeRequestBuilder;
    /**
     * The CreateCsv property
     */
    get createCsv(): CreateCsvRequestBuilder;
    /**
     * The CreateCsvForHcc property
     */
    get createCsvForHcc(): CreateCsvForHccRequestBuilder;
    /**
     * The CreateCsvForTourOperator property
     */
    get createCsvForTourOperator(): CreateCsvForTourOperatorRequestBuilder;
    /**
     * The GetFinal property
     */
    get getFinal(): GetFinalRequestBuilder;
    /**
     * The GetForApproval property
     */
    get getForApproval(): GetForApprovalRequestBuilder;
    /**
     * The GetForHcc property
     */
    get getForHcc(): GetForHccRequestBuilder;
    /**
     * The GetForTourOperator property
     */
    get getForTourOperator(): GetForTourOperatorRequestBuilder;
    /**
     * The GetPath property
     */
    get getPath(): GetRequestBuilder;
    /**
     * The Refresh property
     */
    get refresh(): RefreshRequestBuilder;
    /**
     * The Reject property
     */
    get reject(): RejectRequestBuilder;
    /**
     * The UpdateAllotmentSize property
     */
    get updateAllotmentSize(): UpdateAllotmentSizeRequestBuilder;
    /**
     * The VerifyBusinessRule property
     */
    get verifyBusinessRule(): VerifyBusinessRuleRequestBuilder;
    /**
     * Gets an item from the ApiSdk.Allotment.item collection
     * @param id Unique identifier of the item
     * @returns {AllotmentItemRequestBuilder}
     */
     byId(id: number) : AllotmentItemRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     delete(requestConfiguration?: RequestConfiguration<AllotmentRequestBuilderDeleteQueryParameters> | undefined) : Promise<void>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<AllotmentWithFare>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: AllotmentCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<AllotmentWithFare | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     put(body: AllotmentUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(requestConfiguration?: RequestConfiguration<AllotmentRequestBuilderDeleteQueryParameters> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: AllotmentCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: AllotmentUpdateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
export interface AllotmentRequestBuilderDeleteQueryParameters {
    id?: number;
}
/**
 * Uri template for the request builder.
 */
export const AllotmentRequestBuilderUriTemplate = "{+baseurl}/Allotment";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const AllotmentRequestBuilderNavigationMetadata: Record<Exclude<keyof AllotmentRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byId: {
        requestsMetadata: AllotmentItemRequestBuilderRequestsMetadata,
        navigationMetadata: AllotmentItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["id"],
    },
    approve: {
        requestsMetadata: ApproveRequestBuilderRequestsMetadata,
    },
    approveBatch: {
        requestsMetadata: ApproveBatchRequestBuilderRequestsMetadata,
    },
    cancelUpdateAllotmentSize: {
        requestsMetadata: CancelUpdateAllotmentSizeRequestBuilderRequestsMetadata,
    },
    createCsv: {
        requestsMetadata: CreateCsvRequestBuilderRequestsMetadata,
    },
    createCsvForHcc: {
        requestsMetadata: CreateCsvForHccRequestBuilderRequestsMetadata,
    },
    createCsvForTourOperator: {
        requestsMetadata: CreateCsvForTourOperatorRequestBuilderRequestsMetadata,
    },
    getFinal: {
        requestsMetadata: GetFinalRequestBuilderRequestsMetadata,
    },
    getForApproval: {
        requestsMetadata: GetForApprovalRequestBuilderRequestsMetadata,
    },
    getForHcc: {
        requestsMetadata: GetForHccRequestBuilderRequestsMetadata,
    },
    getForTourOperator: {
        requestsMetadata: GetForTourOperatorRequestBuilderRequestsMetadata,
        navigationMetadata: GetForTourOperatorRequestBuilderNavigationMetadata,
    },
    getPath: {
        requestsMetadata: GetRequestBuilderRequestsMetadata,
    },
    refresh: {
        requestsMetadata: RefreshRequestBuilderRequestsMetadata,
    },
    reject: {
        requestsMetadata: RejectRequestBuilderRequestsMetadata,
    },
    updateAllotmentSize: {
        requestsMetadata: UpdateAllotmentSizeRequestBuilderRequestsMetadata,
    },
    verifyBusinessRule: {
        requestsMetadata: VerifyBusinessRuleRequestBuilderRequestsMetadata,
        navigationMetadata: VerifyBusinessRuleRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const AllotmentRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: "{+baseurl}/Allotment?id={id}",
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
    post: {
        uriTemplate: AllotmentRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createAllotmentWithFareFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAllotmentCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    put: {
        uriTemplate: AllotmentRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeAllotmentUpdateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
